import styled from 'styled-components';
import media from '../../../../styles/media.style';
import { BG_GRAY } from '../../../../styles/variables.style';

export const Hr = styled.div`
  background-color: ${BG_GRAY.COMMON_4};
  height: 3px;
  width: 50px;
  margin: 15px auto 20px calc(50% - 25px);

  ${media.tabletP`
    margin: 26px auto 40px calc(50% - 25px);
  `};
`;

export const Wrapper = styled.div`
  padding: 40px 20px;

  ${media.tabletP`
    padding: 30px;
  `};
`;

export const CareMenu = styled.section`
  padding-top: 40px;
  padding-bottom: 60px;
  border-bottom: solid 1px #d7d7d7;
  border-top: solid 1px #d7d7d7;

  .care-menu__heading {
    font-size: 16px;
    line-height: 1.5em;
    text-align: center;

    ${media.tabletP`
      font-size: 22px;
      text-align: left;
    `};
  }

  .care-menu__paragraph {
    font-size: 12px;
    line-height: 1.5em;
    text-align: center;

    ${media.tabletP`
      text-align: left;
    `};

    span:nth-child(1) {
      font-weight: bold;
    }
  }

  .care-menu__box {
    ${media.tabletP`
      display: table;
      width: 100%;
    `};
  }
  .care-menu__box-left {
    display: none;

    ${media.tabletP`
      display: table-cell;
      vertical-align: bottom;
      text-align: left;
      position: relative;
      width: 260px;
      padding-top: 20px
      padding-right: 40px
    `};
  }
  .care-menu__box-right {
    ${media.tabletP`
      display: table-cell;
      vertical-align: top;
      text-align: left;
    `};
  }

  .care-menu__box2 {
    position: relative;
    width: 250px;
    margin: 40px auto 20px auto;

    ${media.tabletP`
      display: none;
    `};
  }

  .care-menu__image {
    z-index: 1;
    position: relative;
    width: 100%;
    height: auto;

    ${media.tabletP`
      width: 250px;
    `};
  }

  .care-menu__icon {
    position: absolute;
    top: -30px;
    right: -20px;
    width: 80px;
    height: 80px;
    border-radius: 40px;
    text-align: center;
    line-height: 80px;
    font-size: 9px;
    background-color: #cfd9e2;
  }

  .care-menu__button {
    display: block;
    margin: 0 auto;
    border: solid 1px #bbb;
    width: 120px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #000;
    background: none;
    font-size: 11px;

    ${media.tabletP`
      width: 130px;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      margin: 40px 0 0 0;
    `};
  }
`;

export const HomeCare = styled.section`
  padding: 60px 0 0 0;

  .home-care__heading {
    margin-bottom: 30px;
    font-size: 17px;
    line-height: 1.5em;
    text-align: center;

    ${media.tabletP`
      margin-bottom: 50px;
      font-size: 24px;
    `};
  }
`;

export const OtherItems = styled.section`
  .other-items__heading {
    font-size: 17px;
    text-align: center;
    border: solid 1px #bbb;
    line-height: 42px;
    background-color: #edeff0;
    margin: 0;

    ${media.tabletP`
      font-size: 20px;
    `};
  }

  .other-items__box {
    display: table;
    width: 100%;
    border-left: solid 1px #bbb;
    border-right: solid 1px #bbb;
    border-bottom: solid 1px #bbb;
    background-color: #e6f0fa;
  }
  .other-items__box-left {
    display: table-cell;
    vertical-align: top;
    text-align: left;
    padding: 40px 10px 40px 20px;
    box-sizing: border-box;
    width: 50%;

    ${media.tabletP`
      width: 180px;
    `};
  }
  .other-items__box-right {
    display: table-cell;
    vertical-align: top;
    text-align: left;
    padding: 40px 20px 40px 10px;
    box-sizing: border-box;
    width: 50%;

    ${media.tabletP`
      width: auto;
    `};
  }

  .other-items__box2 {
    margin-top: -1px;
    padding: 40px 0 0 0;
    border: solid 1px #bbb;
  }

  .other-items__image {
    width: 100%;
    height: auto;
  }

  .other-items__heading2 {
    font-size: 10px;
    height: 25px;
    line-height: 25px;
    border-radius: 12.5px;
    text-align: center;
    border: solid 1px #bbb;
    margin-bottom: 15px;
    background-color: #fff;

    ${media.tabletP`
      display: inline-block;
      font-size: 11px;
      padding: 0 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #fff;
    `};
  }

  .other-items__paragraph {
    font-size: 11px;
    line-height: 1.5em;

    ${media.tabletP`
      font-size: 12px;
      line-height: 1.5em;
    `};
  }
`;

export const Items = styled.div`
  padding: 0px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.tabletP`
    justify-content: flex-start;
  `};

  .items__list-dl {
    margin-bottom: 30px;
    width: calc(50% - 5px);

    ${media.tabletP`
      width: 25%;
      padding: 0 10px;
      box-sizing: border-box;
    `};

    > dt {
      font-size: 10px;
      height: 25px;
      line-height: 25px;
      border-radius: 12.5px;
      text-align: center;
      border: solid 1px #bbb;
      margin-bottom: 15px;

      ${media.tabletP`
        font-size: 11px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background-color: #fff;
      `};
    }
    > dd {
    }
  }

  .items__image {
    width: 100%;
    height: auto;
    margin-bottom: 15px;
  }

  .items__button {
    position: relative;
    display: block;
    margin: 0 auto 15px auto;
    border: solid 1px #bbb;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #000;
    background: none;
    font-size: 11px;

    ${media.tabletP`
      font-size: 14px;
      height: 45px;
      line-height: 45px;
    `};

    &:before {
      position: absolute;
      top: 50%;
      right: 11px;
      display: block;
      content: '';
      background-color: #bbbbbb;
      height: 1px;
      width: 10px;
    }
    &:after {
      position: absolute;
      top: calc(50% - 5px);
      right: 15px;
      display: block;
      content: '';
      background-color: #bbbbbb;
      height: 11px;
      width: 1px;
    }
  }

  .items__spacer {
    display: block;
    margin: 0 auto 15px auto;
    width: 100%;
    height: 50px;

    ${media.tabletP`
      height: 45px;
    `};
  }

  .items__paragraph {
    font-size: 11px;
    line-height: 1.5em;

    ${media.tabletP`
      font-size: 12px;
      line-height: 1.5em;
    `};
  }
`;

export const SubTitle = styled.div`
  position: relative;
  margin-bottom: 30px;

  ${media.tabletP`
    margin-bottom: 0;
  `};

  .sub-title__box-left {
    margin-bottom: 20px;

    ${media.tabletP`
      margin-bottom: 0;
    `};
  }
  .sub-title__box-right {
    ${media.tabletP`
      position: absolute;
      top: 0;
      right: 0;
    `};
  }
  .sub-title__heading {
    margin: 0;
    font-size: 17px;
    line-height: 50px;
    text-align: center;

    ${media.tabletP`
      margin-bottom: 20px;
      font-size: 24px;
    `};
  }
  .sub-title__button {
    display: block;
    margin: 0 auto;
    border: solid 1px #bbb;
    width: 120px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #000;
    background: none;
    font-size: 11px;

    ${media.tabletP`
      width: 130px;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/SelectedCareMenuPage/SelectedCareMenuPage.style.js